import { ApiProperty } from "@nestjs/swagger";
import { IsOptional, MaxLength, Matches } from "class-validator";
import {AssetStatusEnum} from 'libs/shared-models/common-models/src/lib/enum/asset-status.enum';

export class AssetMaintainanceTransactionsDto{
    @ApiProperty()
    assetMaintainanceTransactionsId : number;

    @ApiProperty()
    assetMaintainanceId : number;

    @ApiProperty()
    assetId :number ;

    @ApiProperty()
    assetLocationId : number;

    @ApiProperty()
    assetCondition : string;

    @ApiProperty()
    maintainanceFrequencyInDays : string;

    @ApiProperty()
    assigned: string;

    @ApiProperty()
    maintainanceType: string;

    @ApiProperty()
    canbeReused: string;

    @ApiProperty()
    owner: string;

    @ApiProperty()
    expiredDate : Date;

    @ApiProperty()
    costOfRepair:string;

    @ApiProperty()
    damageReason: string;

    @ApiProperty()
    remarks: string;

    @ApiProperty()
    status: AssetStatusEnum;

    @ApiProperty()
    isActive : boolean;

    @ApiProperty()
    createdAt : Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 40 characters'})
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), {message: 'Updated User should be only alphabets'})
    createdUser: string;

    @ApiProperty()
    updatedAt : Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 40 characters'})
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), {message: 'Updated User should be only alphabets'})
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;

    assetsName?:string;
    assetsCode?:string;
    itemName?: string;
    employeeName?:string;
    assetCategory?: string;
}